import { useEffect, useRef } from 'react';
import { maybePromptForPush } from '../services/softPushPrompt';

/**
 * Offers the native "turn on notifications" pop-up once per offer per page
 * instance when an offer is waiting on this user (utils/offerAwaitingResponse).
 * The guard is a SET of offer ids, not a boolean, so moving between offers on
 * the same mounted page (a push tap or link to another offer) still gets one
 * chance per offer, while snapshot updates and re-renders of the same offer
 * never re-trigger. The service itself enforces native-only, the real
 * permission check, the 7-day snooze and one pop-up at a time.
 *
 * @param {string|null} offerId
 * @param {boolean} awaiting
 * @param {Function} [prompt]  test seam
 */
export function useReceivedOfferPushPrompt(offerId, awaiting, prompt = maybePromptForPush) {
  const promptedRef = useRef(new Set());
  useEffect(() => {
    if (!awaiting || !offerId) return;
    if (promptedRef.current.has(offerId)) return;
    promptedRef.current.add(offerId);
    Promise.resolve()
      .then(() => prompt('received_offer'))
      .catch(() => {}); // a prompt problem never affects the offer page
  }, [offerId, awaiting]); // eslint-disable-line react-hooks/exhaustive-deps
}
